"use client";
import useTranslation from "next-translate/useTranslation";
import React from "react";
import Lottie from "react-lottie";
import { Button } from "components/ui/v2";
import lottieSuccess from "utils/lottie/success.json";

interface SuccessViewProps {
  text: string;
  size?: number;
  btnLabel?: string;
  btnClick?: () => void;
}

const defaultOptions = {
  loop: true,
  autoplay: true,
  animationData: lottieSuccess,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice"
  }
};

const SuccessView: React.FC<SuccessViewProps> = ({
  text,
  btnLabel,
  btnClick,
  size = 200
}) => {
  const { t } = useTranslation("common");

  return (
    <div className="flex h-full w-full items-center justify-center">
      <div className="flex max-w-sm flex-col">
        <Lottie options={defaultOptions} height={size} width={size} />

        <span className="mb-2 mt-4 text-center text-lg font-bold">
          {t("¡Excelente!")}
        </span>
        <span className="mb-8 text-center">{text}</span>

        {btnLabel && (
          <Button
            variant="primary"
            className="px-20"
            size="lg"
            onClick={btnClick}
          >
            {btnLabel}
          </Button>
        )}
      </div>
    </div>
  );
};

export default SuccessView;
